module.exports = __webpack_public_path__ + "assets/img/a48a-pk.svg";